/**
 * Shared rules for email sign-up and password reset (see docs/ascension-plan.md §8.6).
 *
 * Policy: length-only — at least 8 characters, no digit/symbol requirements.
 * Mirrored server-side in Supabase Auth (password_min_length = 8,
 * password_required_characters = none), so client and server always agree.
 */
export const AUTH_PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_POLICY_LINES = [
  `At least ${AUTH_PASSWORD_MIN_LENGTH} characters`,
] as const;

export interface PasswordPolicyResult {
  ok: boolean;
  lengthOk: boolean;
}

export function evaluatePasswordPolicy(password: string): PasswordPolicyResult {
  const lengthOk = password.length >= AUTH_PASSWORD_MIN_LENGTH;
  return {
    ok: lengthOk,
    lengthOk,
  };
}

/** First validation message for inline forms, or null if satisfied. */
export function passwordPolicyMessage(password: string): string | null {
  const r = evaluatePasswordPolicy(password);
  if (r.ok) return null;
  return `Use at least ${AUTH_PASSWORD_MIN_LENGTH} characters.`;
}
